var _defs, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroMask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "06714b97-aec8-4b7e-bf3d-1e20f95f612e",
    y1: 809.5,
    x2: 958,
    y2: 809.5,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1082)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.05
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hero") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "0567095b-2cf7-4407-b8ab-ec2abe52d830",
    "data-name": "<Path>",
    y: 545,
    width: 1920,
    height: 535,
    fill: "#fff",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "82ca9a61-a0a1-49cc-9805-a3533c693bad",
    "data-name": "<Path>",
    points: "958 545 0 545 0 0 770.96 0 958 545",
    fill: "url(#06714b97-aec8-4b7e-bf3d-1e20f95f612e)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroMask);
export default __webpack_public_path__ + "static/media/hero-mask.59fa99a6e012d22a92934807611022a0.svg";
export { ForwardRef as ReactComponent };